import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {trackEvent} from 'analytics/Analytics';
import {INSIGHTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {getParameterConfigsSpecFromReadShape} from 'insights/analytics-dashboards/RESTAnalyticsDashboardTypes';
import {AnalyticsParameterValue} from 'insights/parameters/__generated/AnalyticsParameterValue';
import {convertGQLToRESTParameterValue} from 'insights/parameters/data/ParameterGQLRESTConverters';
import {AnalyticsParameterConfigSpecRequest} from 'insights/parameters/RESTParameterTypes';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as Colors from 'ui-library/Colors';
import legacyRunModal from 'ui-library/legacyRunModal';

import {AnalyticsParameterConfigGraphQL} from '../../../../graphql-fragments/insights/__generated/AnalyticsParameterConfigGraphQL';
import SQLAssistantModal from './SQLAssistantModal';

export interface SQLAssistantButtonProps {
  draftSQLQuery: string;
  parameterConfigs: Array<AnalyticsParameterConfigGraphQL>;
  parameterValues: Array<AnalyticsParameterValue>;
  setDraftSQLQuery: (sql: string) => void;
  saveAndRunQuery: (sql: string, newParameterConfigs?: Array<AnalyticsParameterConfigSpecRequest>) => void;
}

export default function SQLAssistantButton(props: SQLAssistantButtonProps): JSX.Element {
  return (
    <Tooltip title="SQL Writer" placement={TooltipPlacement.TOP}>
      <Button
        className={css(styles.purpleSparkle)}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        size={ButtonSize.MINI}
        icon="sparkle"
        onClick={() => {
          trackEvent(INSIGHTS_ANALYTICS_ACTIONS.OPENED_SQL_AI_ASSISTANT_MODAL);
          legacyRunModal(SQLAssistantModal, {
            draftSql: props.draftSQLQuery,
            parameterConfigs: getParameterConfigsSpecFromReadShape(props.parameterConfigs),
            parameterValues: props.parameterValues.map((value) => convertGQLToRESTParameterValue(value)),
            onAccept: (
              suggestedSQL: string,
              newParameterConfigs: Array<AnalyticsParameterConfigSpecRequest>
            ) => {
              props.setDraftSQLQuery(suggestedSQL);
              props.saveAndRunQuery(suggestedSQL, newParameterConfigs);
            },
          });
        }}
        dataTestAttrs={{component: 'SQLAssistantButton', element: 'button'}}
      />
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  purpleSparkle: {
    color: Colors.PURPLE,
  },
});
